import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Liability = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Disclaimers and Limitation of Liability</h3>

      <p>
        To the extent permitted by applicable law, the Yoda Safety Services
        website, platform, content, and services are provided on an &quot;as
        is&quot; and &quot;as available&quot; basis. While we take reasonable
        steps to maintain our services and provide useful and accurate workplace
        safety information, we do not guarantee that the website, platform, or
        services will be uninterrupted, error-free, or suitable for every
        workplace, circumstance, or purpose.
      </p>

      <h4>Training and Safety Information</h4>

      <p>
        Training courses, materials, assessments, documentation, and other
        safety information provided through Yoda Safety Services are intended to
        support workplace safety education and training. Requirements may vary
        depending on the workplace, industry, occupation, equipment,
        jurisdiction, and applicable laws, regulations, standards, policies, or
        procedures.
      </p>

      <p>
        Employers, organizations, managers, and users remain responsible for
        determining which training, procedures, documentation, and safety
        requirements apply to their particular workplace and circumstances. Yoda
        Safety Services content is not a substitute for workplace-specific
        hazard assessments, procedures, supervision, professional advice, or
        compliance obligations where those are required.
      </p>

      <h4>Courses, Quizzes, and Assessments</h4>

      <p>
        Successful completion of a course, quiz, or assessment demonstrates
        completion of the applicable Yoda Safety Services training requirements
        but does not guarantee employment, workplace authorization, regulatory
        compliance, competency for every task, or any particular workplace
        outcome.
      </p>

      <p>
        Employers and other organizations are responsible for determining
        whether additional practical training, evaluation, supervision,
        certification, or workplace-specific instruction is required.
      </p>

      <h4>Digital Safety Forms, Manuals, and Documentation</h4>

      <p>
        Digital safety forms, manuals, templates, and other documentation made
        available through the platform are tools intended to assist with
        workplace safety activities and record keeping. Users and organizations
        are responsible for ensuring that the forms, documentation, information,
        and procedures they use are appropriate for their workplace and meet any
        applicable legal, regulatory, contractual, or organizational
        requirements.
      </p>

      <p>
        Yoda Safety Services is not responsible for the accuracy or completeness
        of information entered into forms, records, or documentation by users,
        companies, subcontractors, or other authorized individuals.
      </p>

      <h4>Third-Party Services</h4>

      <p>
        Our platform relies on third-party services for certain functionality,
        including payment processing, hosting, storage, communications, and
        other technology services. Yoda Safety Services is not responsible for
        outages, errors, interruptions, or other issues caused by third-party
        services that are outside our reasonable control.
      </p>

      <p>
        Payments made through the platform are processed by Stripe or another
        authorized payment processor. Yoda Safety Services does not store credit
        card numbers and is not responsible for payment processing issues caused
        by the applicable third-party payment provider, except to the extent
        otherwise required by applicable law.
      </p>

      <h4>User and Company Accounts</h4>

      <p>
        Users are responsible for taking reasonable steps to protect their
        account credentials and for promptly notifying Yoda Safety Services if
        they suspect unauthorized access.
      </p>

      <p>
        Companies and organizations are responsible for managing the access and
        permissions they grant to their managers, employees, subcontractors, and
        other authorized users. Yoda Safety Services is not responsible for
        misuse resulting from permissions or access granted by a company or
        organization, except to the extent that the misuse results from
        circumstances for which Yoda Safety Services is legally responsible.
      </p>

      <h4>Service Availability and Data</h4>

      <p>
        We take reasonable steps to maintain the availability and integrity of
        our platform and services, but we cannot guarantee uninterrupted access
        or that information will never be lost, delayed, corrupted, or
        unavailable. Temporary interruptions may occur due to maintenance,
        technical issues, third-party service failures, security requirements,
        or circumstances outside our reasonable control.
      </p>

      <h4>Limitation of Liability</h4>

      <p>
        To the maximum extent permitted by applicable law, Yoda Safety Services
        will not be liable for indirect, incidental, special, consequential, or
        similar damages arising from or relating to the use of, or inability to
        use, our website, platform, content, or services, including loss of
        profits, revenue, business opportunities, or data.
      </p>

      <p>
        Nothing in these Terms & Conditions excludes, restricts, or limits any
        liability or right that cannot lawfully be excluded, restricted, or
        limited under applicable law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Liability;
